import { useSelector } from 'react-redux';
const ComponentResolver = ({ defaultComponent: DefaultComp, wcaComponent: WcaComp }) => {
  const { companyConfigData } = useSelector((state) => state.authenticate);

  if (companyConfigData?.wabaPartner === 'skalebot') {
    return <WcaComp />;
  }

  return <DefaultComp />;
};

export default ComponentResolver;
